export const galleryItems = [
  {
    id: 'braids-work',
    icon: '👑',
    de: {
      title: 'Braids',
      text: 'Sauber geflochten, angenehm zu tragen und passend zu deinem persönlichen Look.',
    },
    en: {
      title: 'Braids',
      text: 'Clean braiding, comfortable to wear and matched to your personal look.',
    },
  },
  {
    id: 'cornrows-work',
    icon: '〰️',
    de: {
      title: 'Cornrows',
      text: 'Klare Linien, individuelle Muster und ein Style, der zu dir passt.',
    },
    en: {
      title: 'Cornrows',
      text: 'Clean lines, individual patterns and a style that fits you.',
    },
  },
  {
    id: 'dreadlocks-work',
    icon: '🌀',
    de: {
      title: 'Dreadlocks',
      text: 'Pflege, Nacharbeit und Beratung für einen gepflegten natürlichen Look.',
    },
    en: {
      title: 'Dreadlocks',
      text: 'Care, maintenance and consultation for a clean natural look.',
    },
  },
];